export default "__VITE_ASSET__D8_6V1tH__"